const STORAGE_KEY = 'theme'

/** Shared dark mode state — single source of truth for the whole app */
const isDark = ref(false)

function applyDark(val: boolean) {
  if (val) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
  localStorage.setItem(STORAGE_KEY, val ? 'dark' : 'light')
}

/** Call once on app startup to restore preference from localStorage */
export function initDarkMode() {
  const stored = localStorage.getItem(STORAGE_KEY)
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  isDark.value = stored ? stored === 'dark' : prefersDark
  // Apply without writing back to localStorage (already stored or system default)
  if (isDark.value) {
    document.documentElement.classList.add('dark')
  }
}

export function useDarkMode() {
  function toggle(val?: boolean) {
    isDark.value = val !== undefined ? val : !isDark.value
    applyDark(isDark.value)
  }

  return { isDark: readonly(isDark), toggle }
}
